import type { ReactElement } from 'react';
import styled from 'styled-components';

const Link = styled.a`
  ${({ theme }) => theme.typography.paragraph.medium.normal};
`;

export interface EmailAddressProps {
  email: string;
  className?: string;
  onClick?: (event: React.MouseEvent) => void;
}

export function EmailAddress({ email, className, ...props }: EmailAddressProps): ReactElement {
  return (
    <Link className={className} target="_blank" rel="noopener noreferrer" href={`mailto:${email}`} {...props}>
      {email}
    </Link>
  );
}
